<div *ngIf="unavailableRequestsReports.length > 0" class="report-list">
  <div class="overflow-x-auto">
    <div class="table-shell">
      <table class="report-table">
        <colgroup>
          <col class="report-table__col report-table__col--user" />
          <col class="report-table__col report-table__col--contact" />
          <col class="report-table__col report-table__col--reason" />
          <col class="report-table__col report-table__col--description" />
          <col class="report-table__col report-table__col--support" />
          <col class="report-table__col report-table__col--date" />
          <col class="report-table__col report-table__col--company" />
        </colgroup>

        <thead class="border-b border-gray-400">
          <tr>
            <th scope="col">Usuário</th>
            <th scope="col">Contato</th>
            <th scope="col">Motivo</th>
            <th scope="col">Descrição</th>
            <th scope="col">Suporte</th>
            <th scope="col">Data da Solicitação</th>
            <th scope="col">Empresa</th>
          </tr>
        </thead>

        <tbody>
          <tr class="report-table__row" *ngFor="let report of unavailableRequestsReports">
            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.userName || '-'">
                  {{ report.userName || '-' }}
                </span>
                <span
                  class="cell-secondary cell-ellipsis"
                  [title]="report.cpf ? (report.cpf | maskSensitiveInfo) : '-'"
                >
                  CPF: {{ report.cpf ? (report.cpf | maskSensitiveInfo) : '-' }}
                </span>
              </div>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.email || '-'">
                  {{ report.email || '-' }}
                </span>
                <span
                  class="cell-secondary cell-ellipsis"
                  [title]="report.phone ? (report.phone | maskSensitiveInfo) : '-'"
                >
                  Telefone: {{ report.phone ? (report.phone | maskSensitiveInfo) : '-' }}
                </span>
              </div>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-main cell-ellipsis" [title]="report.reason || '-'">
                  {{ report.reason || '-' }}
                </span>
                <span class="cell-secondary cell-ellipsis" [title]="report.reasonType || '-'">
                  Tipo: {{ report.reasonType || '-' }}
                </span>
              </div>
            </td>

            <td>
              <span class="cell-main cell-ellipsis" [title]="report.description || '-'">
                {{ report.description || '-' }}
              </span>
            </td>

            <td>
              <div class="cell-group">
                <span class="cell-secondary cell-ellipsis" [title]="report.onlineSupportEmail || '-'">
                  Online: {{ report.onlineSupportEmail || '-' }}
                </span>
                <span class="cell-secondary cell-ellipsis" [title]="report.offlineSupportEmail || '-'">
                  Offline: {{ report.offlineSupportEmail || '-' }}
                </span>
              </div>
            </td>

            <td>
              <span class="cell-main cell-ellipsis" [title]="(report.requestDate | date: 'dd/MM/yyyy HH:mm') || '-'">
                {{ report.requestDate | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </td>

            <td>
              <span class="cell-main cell-ellipsis" [title]="report.companyName || '-'">
                {{ report.companyName || '-' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-no-results-found [condition]="unavailableRequestsReports.length === 0"></app-no-results-found>

<div class="pagination-wrapper">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
